import * as React from 'react';
import { useEffect } from 'react';
import { BookingSuccessOuterWrapper } from '../Components/_HumanWritten/BookingSuccessPage/BookingSuccessOuterWrapper';
import { BOOKING_SUCCESS_PAGE_TITLE } from 'ConstantPageNames';

export default function BookingSuccessPage() {
	useEffect(() => {
		document.title = BOOKING_SUCCESS_PAGE_TITLE;
	}, []);

	return <BookingSuccessOuterWrapper />;
}
